/**
 * Os blocos extraídos de uma prova num envelope de importação — ADR 045.
 *
 * Mora no pacote compartilhado porque quem junta é a tela, bloco a bloco, e o
 * resultado é o mesmo texto que a pessoa poderia ter colado: vai ao campo de
 * JSON e à conferência de sempre. Nada aqui valida — `importacao.validar` faz.
 *
 * - **Ids de 1 a n, na ordem da prova.** O número original da questão não
 *   serve de id: dois blocos podem repetir número (prova com duas partes) e a
 *   colisão com a trilha o deslocamento já resolve.
 * - **Nome de lote livre.** Sai do título; se já existe um lote com ele na
 *   trilha, ganha `-2`, `-3`… — nome repetido é erro bloqueante na importação.
 */
export function montarEnvelopeDaExtracao(blocos, entrada) {
    const itens = blocos
        .flatMap((b) => b.itens)
        .map((item, i) => {
        const { numero: _numero, id: _id, ...resto } = item;
        return { id: i + 1, ...resto };
    });
    const textosBase = Object.assign({}, ...blocos.map((b) => b.textosBase));
    const envelope = {
        versao: 1,
        trilha: entrada.trilha,
        lote: loteLivre(`prova-${slug(entrada.titulo)}`, entrada.lotesExistentes),
        fonte: `Questões extraídas da prova "${entrada.titulo}"`,
        textosBase,
        itens,
    };
    return {
        texto: JSON.stringify(envelope, null, 2),
        totalItens: itens.length,
        semGabarito: blocos.reduce((s, b) => s + b.semGabarito, 0),
    };
}
function slug(texto) {
    const s = texto
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
        .slice(0, 60)
        .replace(/-+$/, "");
    return s || "sem-titulo";
}
function loteLivre(base, existentes) {
    const usados = new Set(existentes.map((n) => n.toLocaleLowerCase("pt-BR")));
    if (!usados.has(base))
        return base;
    for (let n = 2;; n += 1)
        if (!usados.has(`${base}-${n}`))
            return `${base}-${n}`;
}
//# sourceMappingURL=extracao.js.map